import {clone as cloneObject} from "./clone";
import {id} from "./id-generator";
import axios from "axios";
import retryBase from 'async-retry';
import { pl, enUS, de } from 'date-fns/locale';
import {formatDistanceToNow, isValid} from "date-fns";
import {round} from 'mathjs';
import {createPopper} from "@popperjs/core";

export const getTimestamp = () => Date.now() / 1000;

export const generateId = ((index = 0) => () => (index++).toString())()

export const windowWidthWithoutScrollbar = () => {
    const { innerWidth } = window
    const { clientWidth } = document.documentElement

    if (innerWidth && clientWidth) {
        return Math.min(innerWidth, clientWidth)
    }

    return clientWidth || innerWidth
}

export const parsePrice = (val, places = 2) => {
    if (val === null || val === undefined) {
        val = 0;
    }

    return round(val, places);
};

export function getAjax(url) {
    return $.get(url);
}

export function jsonPost(url, data, options = {}) {
    return $.ajax({
        method: 'POST',
        url: url,
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        ...options
    });
}

export function sendPost(url, data, options) {
    return axios.post(url, data, options);
}

export function getJson(url, options) {
    options = {...{headers: {'Content-Type': 'application/json'}}, ...options};
    return fetch(url, options);
}

export function handleResp(resp) {
    return resp.json()
        .then(data => resp.ok ? data : Promise.reject(data))
        .catch((err) => Promise.reject({...err, status: resp.status}));
}

export function formDataAjax(url, data) {
    return $.post({
        url:url,
        data: data,
        processData: false,
        contentType: false
    });
}

export function deleteAjax(url) {
    return $.ajax({
        method: 'DELETE',
        contentType: 'application/json',
        url: url
    });
}

export const column = (array, key) => array.map(item => item[key]);

export function warnOnUnload() {
    window.onbeforeunload = () => "Are you sure?";
}

export function removeWarnOnUnload() {
    window.onbeforeunload = null;
}

export function isOnBeforeUnloadActive() {
    return !!window.onbeforeunload === true;
}

// list utils
export function searchRoute(q) {
    return Routing.generate('item_search', {q: q});
}

export function imgUrl(id) {
    return Routing.generate('file_get_by_key', {key: id});
}

export function imgByReferenceUrl(id) {
    return Routing.generate('file_get_by_reference', {uid: id});
}

export function listAttachmentSrc(reference, name, listId, itemKey)  {
    return Routing.generate('attachment_get_by_list_item_reference', {uid: reference, name, listId, itemKey});
}

export function proposalAttachmentSrc(reference, name, proposalKey)  {
    return Routing.generate('attachment_get_by_proposal_reference', {uid: reference, name, proposalKey});
}

export function commentAttachmentSrc(reference, name, commentKey, thumb)  {
    return Routing.generate('attachment_get_by_comment_reference', {uid: reference, name, commentKey, thumb});
}

export function actionCommentAttachmentSrc(reference, name, commentKey, thumb)  {
    return Routing.generate('action_attachment_get_by_comment_reference', {uid: reference, name, commentKey, thumb});
}

export function fileSrc(reference, name) {
    return Routing.generate('attachment_get_by_reference', {uid: reference, name});
}

export function projectAttachmentByObjectSrc(reference, projectKey, objectType, objectId) {
    return Routing.generate('attachment_get_by_project_and_object_reference', {
        projectKey: projectKey,
        objectType: objectType,
        objectId: objectId,
        fileRef: reference
    })
}

export function projectAttachmentThumbByObjectSrc(reference, projectKey, objectType, objectId) {
    return Routing.generate('attachment_get_by_project_reference_thumb', {
        projectKey: projectKey,
        objectType: objectType,
        objectId: objectId,
        fileRef: reference,
        thumb: 'small_thumb'
    })
}

export function fileByReferenceSrc(reference, name) {
    return Routing.generate('file_get_by_reference', {uid: reference, name});
}

export function tempFileSrc(reference, name) {
    return Routing.generate('temp_attachment_get_by_reference', {uid: reference, name});
}

export function blogFileSrc(reference, name){
    return Routing.generate('blog_attachment_thumb_get_by_reference', {uid: reference, name});
}

export function imageThumbSrc(reference) {
    return Routing.generate('file_get_thumb_by_reference', {uid: reference});
}

export function imgSrc(photo, index = 0) {
    if (photo.file_references) {
        return imgByReferenceUrl(photo.file_references[index]);
    } else if (photo.id) {
        return imgUrl(photo.id);
    } else if (photo.content) {
        return photo.content;
    } else if (photo.stock) {
        return require(`../../images/stock/${photo.stock}`);
    }
}

export function calculateSubtotalRow(item) {
    item.unit_price = parsePrice(item.unit_price);
    item.measure = parseFloat(item.measure);

    item.price = parsePrice(item.measure * item.unit_price);
}

export function calculateUnitPrice(item) {
    item.price = parsePrice(item.price);
    item.measure = parseFloat(item.measure);

    if (item.measure > 0) {
        item.unit_price = parsePrice(item.price / item.measure);
    }
}

export function formatToCurrency(number, locales, currency = 'PLN') {
    return new Intl.NumberFormat(locales, {style: 'currency', currency: currency}).format(number);
}

export function clone(item) {
    const cloned = cloneObject(item);
    cloned.key = id();
    cloned.created_at = Math.floor(getTimestamp());
    return cloned;
}

export const getRandomColor = () => {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
};

export function sectionBarStyle(section) {
    return `border-color: ${section.color || 'green'}`;
}

export function emptyItem(template) {
    const item = JSON.parse(JSON.stringify(window.allTemplates[template || 'default']));
    item.measure = 1;
    item.key = id();
    item.created_at = Math.floor(getTimestamp());
    return item;
}

export function getFileExt(fileName) {
    return fileName.split('.').pop();
}

export function slugifyName (name, prefix = "") {
    return (
        prefix +
        name
            .toString()
            .trim()
            .toLowerCase()
            .replace(/ /g, "_")
            .replace(/-{2,}/g, "-")
            .replace(/^-+|-+$/g, "")
            .replace(/([^a-zA-Z0-9-_]+)/g, "")
    );
}

export const getParams = (url) => {
    const params = {};
    const parser = document.createElement('a');
    parser.href = url;
    const query = parser.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
};
export const copyToClipboard = str => {
    const el = document.createElement('textarea');
    el.value = str;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
};

export const inputNotFocused = () => {
    return document.activeElement
        && false === isTextBox(document.activeElement)
        && false === document.activeElement.isContentEditable;
}

export function isTextBox(element) {
    const tagName = element.tagName.toLowerCase();
    if (tagName === 'textarea') {
        return true;
    }

    if (tagName !== 'input') {
        return false;
    }

    const type = element.type?.toLowerCase();
    const inputTypes = ['text', 'password', 'number', 'email', 'tel', 'url', 'search', 'date', 'datetime', 'datetime-local', 'time', 'month', 'week'];
    return inputTypes.includes(type);
}

export function modalNotOpened() {
    return false === Array.from(document.getElementsByClassName('modal'))
        .some(modal => modal.classList.contains('show'));
}

export const contains = (str, q) => {
    return str.toLowerCase().includes(q.toLowerCase());
}

export const getHashData = (hash) => {
    function getVal(parts, key) {
        const index = parts.indexOf(key);
        return parts.length > 0 && parts.indexOf(key) !== -1 && parts[index + 1]
            ? parts[index + 1]
            : null;
    }

    const parts = hash[0] === '#'
        ? hash.substring(1).split('-')
        : hash.split('-');

    return {
        proposalKey: getVal(parts, 'proposal'),
        commentId: getVal(parts, 'comment'),
        itemKey: getVal(parts, 'item')
    }
}

export const removeParam = name => {
    const regex = new RegExp(String.raw`[\?&]${name}=[^&]+`);
    window.history.replaceState && window.history.replaceState(
        null,
        '',
        window.location.pathname
        + window.location.search.replace(regex, '').replace(/^&/, '?')
        + window.location.hash
    );
}

export function toggleBodyOverflow(val) {
    document.body.style.overflowY = !val ? 'auto' : 'hidden';
}

export function smoothScrollToEl(id, delay = 0, options = {}) {
    const scroll = (elId) => {
        const el = document.getElementById(elId)
        el && el.scrollIntoView({
            behavior: 'smooth', block: 'center', inline: 'center',
            ...options
        });
    }

    if (delay > 0) {
        setTimeout(() => scroll(id), delay);
    } else {
        scroll(id)
    }
}

export function getValidRedirectedUrl(url) {
    const newUrl = getValidUrl(url);

    if (isHttp(newUrl)) {
        return Routing.generate('link_redirect', {url: encodeURIComponent(newUrl)});
    }

    return newUrl;
}

export function getValidUrl(url) {
    let validUrl = url;
    if (!/^(?:f|ht)tps?\:\/\//.test(url)) {
        validUrl = "http://" + url;
    }
    return validUrl;
}

export function isHttp(link) {
    return link.indexOf("http://") === 0;
}

/**
 * Preloads image to make sure its available
 * even if user goes offline
 */
export function preloadImg(imgUrl) {
    const container = document.createElement('div');
    container.className = 'preloader_container';
    container.style.display = 'none';
    document.body.appendChild(container);

    const i = document.createElement('img');
    i.onload = function () {
        container.appendChild(this);
    };
    i.src = imgUrl;
}

export function hideLoaderDots() {
    document.querySelectorAll('.before-loaded').forEach((item) => {
        item.classList.add('d-none');
    });
}

export function showLoaderDots() {
    document.querySelectorAll('.before-loaded').forEach((item) => {
        item.classList.remove('d-none');
    });
}

export function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}

export function selectInnerText(elem) {
    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(elem);
    selection.removeAllRanges();
    selection.addRange(range);
}

/**
 * Detects browser type, can be one of chrome, firefox, safari
 */
export function detectBrowser() {
    const matchExpressions = {
        chrome: /chrome\/(\d+)/,
        firefox: /firefox\/(\d+)/,
        safari: /safari\/(\d+)/
    };

    if (typeof navigator !== 'undefined'
        && navigator.userAgent
    ) {
        for (var key in matchExpressions) {
            if (matchExpressions.hasOwnProperty(key)
                && navigator.userAgent.toLowerCase().match(matchExpressions[key])
            ) {
                return key;
            }
        }
    }

    return 'other';
}

export function sectionTotalValue(items, excludeCondition, withDiscount = false) {
    return items.reduce((section_total, item) => {
        let price = Number(parseFloat(item.price || 0).toFixed(2));
        if (withDiscount && item.discount > 0 && item.discount <= 100) {
            price = calculateDiscountedPrice(item.discount, price);
        }

        return Number(section_total) + (excludeCondition(item) ? 0 : price);
    }, 0);
}

export function setIntervalX(callback, delay, repetitions, cancelCallback = () => {}) {
    let x = 0;
    const intervalID = window.setInterval(function () {
        callback();
        if (++x === repetitions) {
            window.clearInterval(intervalID);
            cancelCallback();
        }
    }, delay);

    return intervalID;
}

export function exponentialTimeout(delay, fn, maxTries) {
    let id;
    let tries = 0;
    const invoker = () => {
        fn();
        tries++;
        if (maxTries > 0 && tries > maxTries) {
            clearTimeout(id);
            id = null;
            return;
        }

        delay = Math.floor(delay * 2);
        if (delay) {
            id = setTimeout(invoker, delay);
        } else {
            id = null;
        }
    }

    id = setTimeout(invoker, delay);

    return {
        clear: function () {
            if (id) {
                clearTimeout(id);
                id = null;
            }
        }
    }
}

/**
 * search fields in source object by phrases in searched strings
 */
export function matchesPhrase(source, fields, searched) {
    if (searched.trim().length === 0) {
        return true;
    }

    return fields
        .filter(key =>
            source[key]
            && searched.trim().toLowerCase()
                .split(' ')
                .filter((phrase) => phrase.length > 0)
                .some((phrase) => source[key].trim().toLowerCase().includes(phrase.trim()))
        ).length > 0;
}


/**
 * Get last element from array
 */
export function last(array) {
    if (!Array.isArray(array) || array.length === 0) {
        return null;
    }

    return array[array.length - 1];
}

export function isWhite(color) {
    return ['white', '#fff', '#ffffff'].includes(color.toLowerCase());
}

/*
* Get background style for color object
* if color.image is set, it will be used as background image
* otherwise color.color will be used as background color
*
* color.image format: 'img <url>' or '<url>'
* if color.image is 'img <url>' then background-size will be set to contain, and repeat will be set to no-repeat
* if color.image is 'bg <url>' or '<url>' then background will be set to url
*
* @param {object} color - color object
* @param {string} imageKey - key for image url
* @param {string} colorKey - key for color
 */
export function getColorBgStyle(color, imageKey = 'image', colorKey = 'color') {
    if (color[imageKey]) {
        const image = color.image.split(' ');
        if (image.length > 1 && image[0] === 'img') {
            return `url('${image[1]}') center / contain no-repeat`;
        } else if (image.length > 1 && image[0] === 'bg') {
            return `url('${image[1]}')`;
        } else  {
            return `url('${image[0]}')`;
        }
    }

    return color[colorKey] || 'transparent';
}


export function getDomainName(url) {
    const urlMatch = url.match('.*:\/\/([^\/]*)|([^\/]*)');
    return urlMatch?.[1] || urlMatch?.[2] || null;
}

export function getTextColor(hex) {
    if (hex.startsWith('#')) {
        hex = hex.replace('#', '');
    }

    var bigint = parseInt(hex, 16);
    var r = (bigint >> 16) & 255;
    var g = (bigint >> 8) & 255;
    var b = bigint & 255;

    const brightness = Math.round((r * 299) + (g * 587) + (b * 114) / 1000);
    return (brightness > 125) ? '#45455E' : '#FFFFFF';
}


export function calculateDiscountedPrice(discount, price) {
    discount = discount < 0 ? 0 : discount > 100 ? 100 : discount;
    return price - (price * (discount / 100));
}

export function isObject(variable) {
    return Object.prototype.toString.call(variable) === '[object Object]';
}

export function maybe(val, defaultVal) {
    return undefined === val ? defaultVal : val;
}
export function inRange(min, max, val) {
    return val >= min && val <= max;
}
export function replaceURLWithHTMLLinks(text, blank = false) {
    var exp = /((href|src)=["']|)(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
    return text.replace(exp, function() {
        return arguments[1] ?
            arguments[0] :
            `<a ${blank ? 'target="_blank"' : ''} href="${arguments[3]}">${arguments[3]}</a>`
    });
}

export function retry(fn, opts = {}) {
    return retryBase(fn, {retries: 3, randomize: false, minTimeout: 750, ...opts});
}

export function rethrow(e) {
    throw e;
}

export function stripHtml(html, excludeTags = []) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    if (excludeTags.length > 0) {
        return doc.body.querySelectorAll(excludeTags.join(', ')).length > 0 ? doc.body.innerHTML : doc.body.textContent || '';
    }
    return doc.body.textContent || '';
}

/**
 * Check if element is hidden, i.e. has display: none or parent element has display: none
 */
export function isHidden(element) {
    return element.offsetParent === null;
}

export function createBoundingClientElement(x, y) {
    return {
        getBoundingClientRect: () => ({
            width: 0,
            height: 0,
            top: y,
            right: x,
            bottom: y,
            left: x,
        }),
    };
}

export function isTrue(value) {
    return value === true || value === 'true';
}

export function getInitialsFromName(name) {
    return String(name)
        .split(' ')
        .map(word => word[0])
        .splice(0, 2)
        .join('')
        .toUpperCase();
}

export function matchSelectorOrHasParentWithMatchingSelector (target, selector, scope = document) {
    if (typeof scope === 'string') {
        const newScope = document.querySelector(scope);
        if (newScope) {
            scope = newScope;
        }
    }

    return [...scope.querySelectorAll(selector)].some(el =>
        el === target || el.contains(target)
    )
}

export function isoDateTimeWithoutSeconds(dateString) {
    // Split the date string into date and time parts (using a regular expression)
    const match = dateString.match(/(\d{4}-\d{2}-\d{2}) (?:(\d{2}):(\d{2}))?/);

    if (!match) {
        // Invalid date format, return original string
        return dateString;
    }
    const [, date, hours, minutes] = match;
    const hasSeconds = minutes && minutes.length === 2;
    return hasSeconds ? `${date} ${hours}:${minutes.slice(0, 2)}` : dateString;
}

export function monitorTask({ id, onUpdate, onComplete, onError, onCancel }) {
    let startTime = Date.now();
    let checkInterval = null;
    let reducedInterval = false;

    const delayMs = 5000; // 5 seconds
    const maxTime = delayMs * 10; // 5 minutes
    const initialMaxTime = 60000; // one minute
    const delayedInterval = 1000; // 5 seconds

    const checkStatus = () => {
        getAjax(Routing.generate('task_check', { id }))
            .then(({ result, message }) => {
                // Always emit status updates
                onUpdate?.({
                    result,
                    message,
                    elapsedTime: (Date.now() - startTime) / 1000,
                    delayed: reducedInterval
                });

                if (result === "success") {
                    clearInterval(checkInterval);
                    checkInterval = null;
                    onComplete?.({ id, message });
                } else if (result === "failed") {
                    clearInterval(checkInterval);
                    checkInterval = null;
                    onError?.({ id, message });
                } else if (result === "cancelled") {
                    clearInterval(checkInterval);
                    checkInterval = null;
                    onCancel?.({ id, message });
                } else if ((result === "not_started" || result === 'in_progress')
                    && false === reducedInterval
                    && (Date.now() - startTime) > delayMs
                ) {
                    // After 20 seconds, reduce interval and extend timeout
                    clearInterval(checkInterval);
                    reducedInterval = true;
                    checkInterval = setInterval(checkStatus, delayedInterval);

                    // Set extended timeout (5 minutes total)
                    setTimeout(() => {
                        if (checkInterval) {
                            clearInterval(checkInterval);
                            checkInterval = null;
                            onError?.({ id, message: 'Task timed out after extended wait' });
                        }
                    }, maxTime - delayMs);
                }
            })
            .catch((error) => {
                clearInterval(checkInterval);
                checkInterval = null;
                onError?.({ id, error });
            });
    };

    // Start with 1 second interval
    checkInterval = setInterval(checkStatus, 1000);

    // Set initial timeout
    setTimeout(() => {
        if (checkInterval && !reducedInterval) {
            clearInterval(checkInterval);
            onError?.({ id, message: 'Task timed out after 1 minute' });
        }
    }, initialMaxTime);

    // Return a function to cancel monitoring
    return {
        cancel: () => {
            if (checkInterval) {
                clearInterval(checkInterval);
                checkInterval = null;
            }
        }
    };
}

export function getDateFnsLocale(locale) {
    let result = pl;
    switch (locale) {
        case 'pl':
            result = pl;
            break;
        case 'en':
            result = enUS;
            break;
        case 'de':
            result = de;
            break;
    }

    return result;
}

export function getDateDistance(date, locale) {
    const dateInstance = new Date(date);
    if (!isValid(dateInstance)) {
        return '';
    }

    return formatDistanceToNow(dateInstance, { addSuffix: true, locale: getDateFnsLocale(locale) })
}

export function buildParams(data) {
    const params = new URLSearchParams()

    Object.entries(data).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach(value => params.append(`${key}[]`, value.toString()))
        } else {
            params.append(key, value.toString())
        }
    });

    return params.toString();
}

export function arrayMoveMutable(array, fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? array.length + fromIndex : fromIndex;

    if (startIndex >= 0 && startIndex < array.length) {
        const endIndex = toIndex < 0 ? array.length + toIndex : toIndex;
        const [item] = array.splice(fromIndex, 1);
        array.splice(endIndex, 0, item);
    }
}


export function arrayMoveImmutable(array, fromIndex, toIndex) {
    array = [...array];
    arrayMoveMutable(array, fromIndex, toIndex);

    return array;
}

export function clickEventType() {
    return document.ontouchstart !== null ? 'click' : 'touchstart';
}

export function truncateText(value, length, character = '...') {
    return value.length > length
        ? value.slice(0, length) + character
        : value;
}

export function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export function loadImagesRange(images, index, range = 2) {
    const getImagesToLoad = () => {
        const max = images.length;
        const min = 0;
        const start = index - range < 0 ? min : index - range;
        const end = (index) + range > max ? max : (index) + range;

        return images.slice(start, end);
    }

    const result = getImagesToLoad();
    loadImages(result);
}

export async function loadImages(images = []) {
    return Promise.all(images.map((src) => {
        if (!src) return Promise.resolve(null);

        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => resolve({ src, width: img.width, height: img.height });
            img.onerror = () => resolve(null);
            img.src = src;
        });
    })).then(results => results.filter(Boolean));
}

export function convertToDateIgnoringTimezone(datetimeString) {
    const dateOnlyRegex = /^\d{4}-\d{2}-\d{2}$/; // Matches 'YYYY-MM-DD'
    const dateTimeRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/; // Matches 'YYYY-MM-DD HH:MM'

    if (dateOnlyRegex.test(datetimeString)) {
        return new Date(datetimeString + 'T00:00:00');
    } else if (dateTimeRegex.test(datetimeString)) {
        const formattedString = datetimeString.replace(' ', 'T');
        const date = new Date(formattedString + ':00');
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes());
    } else {
        return null;
    }
}

export function formatNumber(value, places = 2) {
    return parsePrice(value, places);
}

export function getWeekNumber(date) {
    const currentDate = new Date(date);
    const startOfYear = new Date(currentDate.getFullYear(), 0, 1);
    const days = Math.floor((currentDate - startOfYear) / (24 * 60 * 60 * 1000));

    const weekNumber = Math.ceil((days + startOfYear.getDay() + 1) / 7);
    return weekNumber;
}

export const doubleRequestAnimationFrame = (callback) => {
    requestAnimationFrame(() => {
        requestAnimationFrame(callback)
    })
}

export const forceNextTick = (callback) => {
    if (callback && typeof callback === 'function') {
        doubleRequestAnimationFrame(callback)
    } else {
        return new Promise(resolve => {
            doubleRequestAnimationFrame(resolve)
        })
    }
}

export function addUrlSearchParams(params) {
    const url = new URL(window.location.href);

    Object.entries(params).forEach(([key, value]) => {
        if (!key || typeof value !== 'string') {
            return;
        }

        url.searchParams.set(key, value);
    })

    window.history.pushState(null, '', url.toString());
}

export function deleteUrlSearchParams(params = []) {
    const url = new URL(window.location.href);

    params.forEach((key) => {
        url.searchParams.delete(key);
    })

    window.history.pushState(null, '', url.toString());
}

export function urlSearchParamsIncludes(key) {
    const url = new URL(window.location.href);

    return url.searchParams.has(key);
}

export function getUrlSearchParam(key) {
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop ?? ''),
    });

    return params[key] ?? null;
}

export function highlightInboxElement(e, tooltipText) {
    e.classList.add('ui-highlight-inbox');

    const tooltip = document.createElement('div');
    tooltip.className = 'ui-highlight-tooltip';

    if (typeof tooltipText === 'string' && tooltipText.length > 0) {
        const badge = document.createElement('div');
        badge.className = 'ui-badge ui-badge-tooltip';
        badge.textContent = tooltipText;
        Object.assign(badge.style, {
            background: '#f2994a',
        });

        tooltip.appendChild(badge);
    }

    document.body.appendChild(tooltip);

    Object.assign(tooltip.style, {
        pointerEvents: 'none',
    });

    createPopper(e, tooltip, {
        placement: 'top-end',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0],
                },
            },
            {
                name: 'flip',
                enabled: false,
            },
        ],
    });
}
